
import { Component, Vue } from "vue-property-decorator";
import api from "@/network/api";
import { AxiosResponse, AxiosError } from "axios";
import { Getter } from "vuex-class";
import { Route } from "vue-router";
import { Locales } from "../../i18n/locales";

@Component
export default class ChangePasswordPage extends Vue {
  @Getter("forceReset") private forceReset!: boolean;
  private password = "";
  private newPassword = "";
  private newPasswordConfirmation = "";
  private errors: string[] = [];
  private passwordChanged = false;

  @Getter("userSource") private userSource!: number;

  checkForm(): void {
    this.errors = [];

    if (this.newPassword !== this.newPasswordConfirmation) {
      this.errors.push("Confirm password must match new password");
    }

    if (this.password === this.newPassword) {
      this.errors.push("New password cannot be the same as current password");
    }

    if (!/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}/.test(this.newPassword)) {
      this.errors.push("passwordComplexity");
    }
  }

  clearForm(): void {
    this.password = "";
    this.newPassword = "";
    this.newPasswordConfirmation = "";
  }

  changePassword(): void {
    this.checkForm();

    if (!this.errors.length) this.sendRequest();
  }

  sendRequest(): void {
    api
      .put("/auth/user/password", {
        password: this.password,
        // eslint-disable-next-line @typescript-eslint/camelcase
        new_password: this.newPassword,
        // eslint-disable-next-line @typescript-eslint/camelcase
        new_password_confirmation: this.newPasswordConfirmation
      })
      .then((res: AxiosResponse) => {
        (Vue as any).$toast.success(res.data.message, {
          position: this.$i18n.locale === Locales.EN ? "top-right" : "top-left"
        });

        this.clearForm();

        this.passwordChanged = true;
        this.$store.dispatch("getUserData");
      })
      .catch(err => {
        (Vue as any).$toast.error(err.data.message, {
          position: this.$i18n.locale === Locales.EN ? "top-right" : "top-left"
        });
      });
  }

  redirectHome(): void {
    this.$router.push("/");
  }

  beforeRouteLeave(to: Route, from: Route, next: CallableFunction) {
    if (this.forceReset) {
      next(false);
    } else {
      next();
    }
  }

  created() {
    if (this.userSource !== 1) {
      this.redirectHome();
    }
  }
}
